var codeblock_default = {
  "blockStyleSpacing": "_3C2qc",
  "codeBlock": "_9enJf _3C2qc",
  "renderedInTable": "UhNzu"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
